/* TASK 41 — MENU behaviors (owner-LOCKED mocks desktop-v3 + mobile-v4).
   Desktop: hover-intent ~120ms άνοιγμα · rail switch σε mouseenter · ΕΝΑ panel
   ανοιχτό · veil «Μετάξι» · κλείσιμο mouseleave(220ms)/Esc/veil-click · click σε
   L1 = toggle panel (touch fallback), 2ο click = πλοήγηση στο href.
   Mobile: 3-βήματα push (class toggles πάνω σε server-rendered δέντρο) ·
   accordion οικογένειες ΟΛΕΣ κλειστές. IIFE, κανένα global. */
(function () {
  'use strict';

  /* ---- desktop ---- */
  var nav = document.querySelector('[data-tj-nav]');
  var veil = document.querySelector('[data-tj-veil]');
  if (nav && veil) {
    var l1s = Array.prototype.slice.call(nav.querySelectorAll('.tj-l1[data-tj-l1]'));
    var openIdx = null, hoverT = null, intentT = null;

    function paint() {
      nav.querySelectorAll('.tj-megawrap').forEach(function (w) {
        w.classList.toggle('open', w.getAttribute('data-tj-mega') === String(openIdx));
      });
      l1s.forEach(function (a) {
        var on = a.getAttribute('data-tj-l1') === String(openIdx);
        a.classList.toggle('on', on);
        a.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      veil.classList.toggle('on', openIdx !== null);
    }
    function openK(i) { openIdx = i; paint(); }
    function close() { openIdx = null; paint(); }

    l1s.forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        clearTimeout(hoverT);
        clearTimeout(intentT);
        intentT = setTimeout(function () { openK(a.getAttribute('data-tj-l1')); }, 120);
      });
      a.addEventListener('click', function (e) {
        /* touch/tablet fallback: 1ο tap ανοίγει, 2ο tap = πλοήγηση */
        if (openIdx !== a.getAttribute('data-tj-l1')) {
          e.preventDefault();
          openK(a.getAttribute('data-tj-l1'));
        }
      });
    });
    nav.addEventListener('mouseleave', function () {
      clearTimeout(intentT);
      hoverT = setTimeout(close, 220);
    });
    nav.addEventListener('mouseenter', function () { clearTimeout(hoverT); });
    veil.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* rail: mouseenter αλλάζει pane (το click = κανονική πλοήγηση στο group url) */
    nav.addEventListener('mouseenter', function (e) {
      var r = e.target.closest && e.target.closest('.tj-rail a[data-tj-g]');
      if (!r) return;
      var wrap = r.closest('.tj-megawrap');
      var gi = r.getAttribute('data-tj-g');
      wrap.querySelectorAll('.tj-rail a').forEach(function (x) { x.classList.toggle('on', x === r); });
      wrap.querySelectorAll('.tj-pane').forEach(function (p) {
        var on = p.getAttribute('data-tj-pane') === gi;
        if (on && !p.classList.contains('on')) { p.classList.remove('on'); void p.offsetWidth; }
        p.classList.toggle('on', on);
      });
    }, true);
  }

  /* ---- mobile: 3-step push ---- */
  var mm = document.querySelector('.tj-mm [data-tj-mm]');
  if (mm) {
    mm.addEventListener('click', function (e) {
      var t = e.target.closest('button, a');
      if (!t) return;
      if (t.hasAttribute('data-tj-open-l2')) {
        mm.querySelectorAll('.tj-mm-lvl.on').forEach(function (x) { x.classList.remove('on'); });
        var l2 = mm.querySelector('[data-tj-l2="' + t.getAttribute('data-tj-open-l2') + '"]');
        if (l2) { l2.classList.add('on'); l2.scrollTop = 0; }
      } else if (t.hasAttribute('data-tj-open-l3')) {
        var l3 = mm.querySelector('[data-tj-l3="' + t.getAttribute('data-tj-open-l3') + '"]');
        if (l3) { l3.classList.add('on'); l3.scrollTop = 0; }
      } else if (t.hasAttribute('data-tj-back')) {
        t.closest('.tj-mm-lvl').classList.remove('on');
      } else if (t.hasAttribute('data-tj-back3')) {
        t.closest('.tj-mm-lvl').classList.remove('on');
      } else if (t.hasAttribute('data-tj-fam')) {
        var body = t.nextElementSibling;
        var on = body.classList.toggle('on');
        t.querySelector('.mk').textContent = on ? '−' : '+';
      }
    });
    /* reset στο κλείσιμο: την επόμενη φορά ξεκινά από το βήμα-1 */
    var dlg = document.querySelector('dialog.tj-mm');
    if (dlg) dlg.addEventListener('close', function () {
      mm.querySelectorAll('.tj-mm-lvl.on').forEach(function (x) { x.classList.remove('on'); });
      mm.querySelectorAll('.tj-mm-famb.on').forEach(function (x) { x.classList.remove('on'); });
      mm.querySelectorAll('.tj-mm-famh .mk').forEach(function (x) { x.textContent = '+'; });
    });
  }
})();
